export default __webpack_public_path__ + "./images/apple.07e6e5f9.svg";